module.exports = __webpack_public_path__ + "static/img/service-08.5f80e29d.png";